import React from 'react';
import { useRef, useState, forwardRef, useEffect } from 'react';
import './../css/Project.css';
import MartCartImg from './../../Assets/MartcartMockups.png';
import FramezyImg from './../../Assets/FramezyMockups.png';
import NotesAppImg from './../../Assets/NotesAppMockups.png';
import Vspire from './../../Assets/VS.png';
import ecommerce from './../../Assets/e-commerce.png';
import spotify from './../../Assets/spotify.jpeg';
import Theportfolyo from './../../Assets/Theportfolyo.png';
import v1 from './../../Assets/v1.png';
import PasteElementImg from './../../Assets/PasteElement.png';
import DesignByteImg from './../../Assets/DesignByte.png';

const projectList = [
  {
    title: 'ThePortfolyo',
    img: Theportfolyo,
    desc: 'Developed an industry-first AI-powered platform that instantly generates a professional portfolio from a resume in under 5 seconds — revolutionizing the way individuals showcase their skills and experience online.',
    visit: 'https://theportfolyo.com/',
    github: '#',
    tech: ['React', 'Node.js', 'MongoDB', 'OpenAI', 'AWS', 'CI/CD']
  },
  {
    title: 'V1.ThePortfolyo',
    img: v1,
    desc: 'Developed a platform where people can build websites using our AI-powered CMS. Hosted more than 150 world-class websites live.',
    visit: 'https://v1.theportfolyo.com/',
    github: '#',
    tech: ['React', 'CMS', 'AI', 'Node.js']
  },
  {
    title: 'PasteElement',
    img: PasteElementImg,
    desc: 'World\'s largest Elementor component and template library with over 4,500 ready-to-use components and 3,000 complete website templates for WordPress developers and designers. Build professional websites faster with our copy-paste solution.',
    visit: 'https://pasteelement.com/',
    github: '#',
    tech: ['Next.js', 'JavaScript', 'Elementor', 'WordPress', 'Component Library']
  },
  {
    title: 'DesignByte',
    img: DesignByteImg,
    desc: 'Premium marketplace for developer resources that follow strict standards and best practices for modern web development. Every template, starter kit, and design resource is meticulously crafted to ensure quality, maintainability, and exceptional developer experience.',
    visit: 'https://designbyte.shop/',
    github: '#',
    tech: ['TypeScript', 'Tailwind CSS', 'Shadcn UI', 'React', 'Next.js', 'Templates']
  },
  {
    title: 'LegalSeva Web App',
    img: FramezyImg,
    desc: 'An app where you can consult lawyers. This application is the connector between clients and lawyers.',
    visit: 'https://legalseva.org/',
    github: '#',
    tech: ['React', 'Node.js', 'Web App']
  },
  {
    title: 'Food_Cart App',
    img: MartCartImg,
    desc: 'A Food_Order website where you can buy items.',
    visit: 'https://shanmukh405.github.io/Restaurant-Web-design/',
    github: '#',
    tech: ['React', 'SPA', 'SQL']
  },
  {
    title: 'Resume WebDesign and Data Visualization Projects',
    img: NotesAppImg,
    desc: 'A WebDesign and Data Visualization project.',
    visit: 'https://shanmukh405.github.io/Shanmukh-Portfolio/',
    github: 'https://github.com/SHANMUKH405/Data-Science',
    tech: ['React', 'JWT', 'Data Viz']
  },
  {
    title: "A Startup's Responsive WebApp",
    img: Vspire,
    desc: 'A Web Application for startups.',
    visit: 'https://vishnuspireapp.netlify.app/',
    github: 'https://github.com/SHANMUKH405/',
    tech: ['React', 'JWT', 'SQL']
  },
  {
    title: 'E-commerce Full Responsive React App',
    img: ecommerce,
    desc: 'A full-featured e-commerce React app.',
    visit: 'https://e-commercedata.netlify.app/',
    github: 'https://github.com/SHANMUKH405/',
    tech: ['React', 'JWT', 'SQL']
  },
  {
    title: 'Many Clones',
    img: spotify,
    desc: 'Cloned multiple billion-dollar company websites.',
    visit: 'https://github.com/SHANMUKH405/Airbnc',
    github: 'https://github.com/SHANMUKH405/Airbnc',
    tech: ['React', 'Clones']
  }
];

const Projects = forwardRef((props, ref) => {
  const [vis, setVis] = useState(0);

  const handleScroll = () => {
    if (ref.current !== null) {
      var pixelsScrolled = (window.pageYOffset - ref.current.offsetTop + window.innerHeight);
      var compHeight = ref.current.clientHeight;
      var percentScrolled = (pixelsScrolled / compHeight) * 100;
      if (percentScrolled < 8 && vis !== 0) setVis(0);
      if (percentScrolled >= 8 && percentScrolled < 30 && vis !== 1) setVis(1);
      if (percentScrolled >= 30 && percentScrolled < 60 && vis !== 2) setVis(2);
      if (percentScrolled >= 60 && vis !== 3) setVis(3);
    }
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [vis]);

  return (
    <section ref={ref} className="container projects">
      <h1 className="mainHeading">SOME OF MY PROJECTS</h1>
      <div className="projectbgbox1"></div>
      <div className="projectbgbox2"></div>
      <div className="projectbgbox3"></div>
      <div className="project-card-list">
        {projectList.map((proj, idx) => (
          <div className={`project-card-modern ${vis >= 1 ? 'show' : ''}`} key={idx}>
            <div className="project-img-wrap">
              <img src={proj.img} alt={proj.title + ' screenshot'} loading="lazy" />
            </div>
            <div className="project-content-wrap">
              <h2>{proj.title}</h2>
              <p>{proj.desc}</p>
              <div className="project-tags">
                {proj.tech.map((tag, i) => (
                  <span className="project-tag" key={i}>{tag}</span>
                ))}
              </div>
              <div className="projectButtons">
                <a href={proj.visit} className="projbtnprim" target="_blank" rel="noopener noreferrer"><i className="fas fa-eye"></i> Visit</a>
                {proj.github && <a href={proj.github} className="projbtnsec" target="_blank" rel="noopener noreferrer"><i className="fab fa-github"></i> Github Repo</a>}
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
});

export default Projects;